<template>
  <div>
    <MainViewFrame style="min-height:100vh">
      <div class="activityDetail">
        <div class="picture">
          <img class="activityimg" :src="currentActivity && currentActivity.photo" />
        </div>
      </div>
      <template v-if="currentActivity && currentActivity.activity_tag === 'showwork'">
      <div class="btns" slot="rightBtn">
        <button @click="chooseWork()">选择作品</button>
        <button @click="goWebSite()">上传作品</button>
      </div>
      <div class="lists">
        <!-- 只有一个组别则不选择 -->
        <div class="tabs" v-if="typeArr.length > 1">
          <span
            v-for="item in typeArr"
            :key="item.type"
            :class="{actvie:work_type==item.type}"
            @click="work_type=item.type"
          >{{item.name}}</span>
        </div>
        <WorkList
          v-if="currentActivity"
          data-type="activity_works"
          :number="currentActivity.number"
          :work_type="work_type"
        />
      </div>
      </template>
      <template v-else-if="currentActivity && currentActivity.activity_tag === 'video'">
        <div class="btns" slot="rightBtn">
          <button @click="uploadVideo()">上传视频</button>
        </div>
        <div class="videos">
          <div class="videoItem" @click="videoItemDetail(item)" v-for="item in activity_video_data" :key="item.pk">
            <span class="banner" :style="{ backgroundImage: `url(${getImg(item.banner, false)})`}"></span>
            <span class="title">{{item.title}}</span>
            <div class="authorWrapper">
              <img class="avatar" :src="item.owner.avatar" />
              <span class="name">{{ item.owner.name }}</span>
            </div>
          </div>
        </div>

        <div class="inputViewContainerShadow" v-if="show_input_shadow">
          <div class="inputViewContainer">
            <InputView 
              type="activity_video" 
              @publish="publish"
            />
            <span class="close" @click="hideInputView()">
              <span class="line1"></span>
              <span class="line2"></span>
            </span>
          </div>
        </div>

      </template>
    </MainViewFrame>
  </div>
</template>

<script>
// @ is an alias to /src
import MainViewFrame from "@/views/MainViewFrame.vue";
import WorkList from "@/views/WorkList.vue";
import InputView from "@/views/components/InputView.vue";


import { Utils } from "@/utils";
// import Works from "./scratch/components/Works.vue";

import { types as ActivityTypes } from "@/store/modules/activity.js";
import { types as LoginTypes } from "@/store/modules/login";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { IMG_COMPANY_UPDATE_ICON, IMG_INVITE_ICON } from "@/assets";

export default {
  name: "AcitivityDetail",
  components: {
    MainViewFrame,
    WorkList,
    InputView
  },
  data() {
    return {
      work_type: "",
      typeArr: [],
      number:'',
      show_input_shadow: false
    };
  },
  watch: {
    currentActivity (value) {
      if(value && value.activity_tag === 'video'){
        this.fetchAcitvityVideoList({page:1, activity_number:this.number})
      }
      if (this.currentActivity.is_scratch) {
        let obj = {
          type: "scratch3",
          name: "创作组"
        };
        this.typeArr.push(obj);
      }
      if (this.currentActivity.is_applab) {
        let obj = {
          type: "applab",
          name: "开发组"
        };
        this.typeArr.push(obj);
      }

      if (this.typeArr.length > 0) {
        this.work_type = this.typeArr[0].type;
      } else {
        // this.$message.error('该活动设置有误，请检查')
      }
    }
  },
  computed: {
    ...mapState({
      currentActivity: state => state.activity.currentActivity,
      userInfo: state => state.login.userInfo,

      activity_video_data: state => state.activity.activity_video.data,
      activity_video_page: state => state.activity.activity_video.page,
      activity_video_load_more: state => state.activity.activity_video.load_more
    })
  },
  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchDetail: ActivityTypes.FETCH_DETAIL_ACTIVITY,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchAcitvityVideoList: ActivityTypes.FETCH_LIST_ACTIVITY_VIDEO,
      fetchCreateActivityVideo: ActivityTypes.FETCH_CREATE_ACTIVITY_VIDEO
    }),
    ...Utils,
    endtime() {
      let time = this.currentActivity.end_time ? new Date(this.currentActivity.end_time): null;
      let nowTime = new Date();
      if (nowTime > time) {
        //现在时间大于结束时间，说明活动已经结束
        return false;
      } else {
        return true;
      }
    },
    // 去其他网页
    goWebSite() {
      if (!this.endtime()) {
        this.$message.error("活动已结束");
        return;
      }
      // this.endtime()
      // https://www.coding61.com/html/neumann/add.html
      let url = `/html/neumann/add.html?number=${this.currentActivity.number}`;
      if (location.host.includes("develop")) {
        url = `https://develop.coding61.com/html/neumann/add.html?number=${this.currentActivity.number}`;
      }
      window.open(url, "_blank");
    },
    // 进入个人主页，选择作品
    chooseWork(){
      if (!this.endtime()) {
        this.$message.error("活动已结束");
        return;
      }
      let callback = ()=>{
      this.$router.push(`/profile/${this.userInfo.user_id}?tag=work&number=${this.number}`)
      }
      this.dependLoginStatus().then(callback)
    },

    // 上传视频
    uploadVideo(){
      this.showInputView()
    },
    // 打开输入框
    showInputView () {
      let callback = ()=>{
        this.show_input_shadow = true;
      }
      this.dependLoginStatus().then(callback)
    },
    hideInputView () {
      this.show_input_shadow = false
    },
    // 视频 item 点击事件
    videoItemDetail(item){
      window.open(
        `${item.video}`,
        "_blank"
      );
    },
    handleScroll(e){
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      let load_more = that.activity_video_load_more
      let page = that.activity_video_page

      if (scrollHeight <= height + scrollTop + 20) {
        if (load_more) {
          console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchAcitvityVideoList({page:page+1, activity_number:that.number})
        } else {
          console.log("没有新数据了");
        }
      } else {
        console.log("没到底部");
      }
    },

    //-------------inputView 组件的回调函数
    publish (type, data) {
      let dic = {
        "title":data.title,
        "content":data.content,
        "video":data.videos,
        "banner":data.poster_url,
        "activity_number": this.number
      }
      this.fetchCreateActivityVideo(dic)
      this.hideInputView()
    },
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.number = this.$route.params.number;
    this.fetchDetail({ pk: this.number });
    this.dependLoginStatus("no_toast").then(()=>{
      this.fetchOwnInfo()
    })
  }
};
</script>

<style lang="less" scoped>
.btns {
  button {
    height: 30px;
    padding: 0 20px;
    background: transparent;
    border: 1px solid #ffffff;
    font-size: 17px;
    border-radius: 15px;
    color: #ffffff;
    margin-left: 30px;
    cursor: pointer;
  }
}
.lists {
  width: 100%;
  background: rgba(246, 246, 246, 1);
  border-radius: 0.4rem;
  margin-top: 0.5rem;
  .tabs {
    width: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
    width: 100%;
    span {
      height: 26px;
      font-size: 14px;
      line-height: 26px;
      color: #333333;
      padding: 0 5px;
      cursor: pointer;
      &:first-child {
        margin-right: 25px;
      }
      &:last-child {
        margin-left: 25px;
      }
    }
    span.actvie {
      border-bottom: solid 2px #6b45e1;
    }
  }
}
.activityDetail {
  width: 100%;
  border-radius: 0.25rem;
  overflow: hidden;
  .activityimg {
    display: block;
    width: 100%;
    border-radius: 0.4rem;
    background-color: palegoldenrod;
  }
}

.videos{
  background: #ffffff;
  margin-top: 10px;
  border-radius: 5px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-right: 10px;
  padding-top: 10px;
  .videoItem{
    width: calc(100% / 4 - 12px);
    margin-left: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    border: solid 1px #EBEBEB;
    .banner{
      display: inline-block;
      width: 100%;
      height: 150px;
      background: #F4F3F3;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .title{
      margin-top: 10px;
      color: #333333;
      font-size: 14px;
      margin-bottom: 10px;
      padding-left: 5px;
    }
    .authorWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 5px;
      padding-left: 5px;
      padding-top:5px;
      border-top: solid 1px #EBEBEB;
      .avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 5px;
      }
      .name {
        font-size: 11px;
        color: #666666;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
      }
    }
  }
}

.inputViewContainerShadow {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 300;
  position: fixed;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  .inputViewContainer {
    width: 770px;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: -50px;
      top: 0;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 20px;
        height: 1.5px;
        background-color: #644ed9;
        top: calc(50% - 1px);
      }
      .line2 {
        width: 1.5px;
        height: 20px;
        background-color: #644ed9;
      }
    }
  }
}
</style>
